module.exports = __webpack_public_path__ + "static/media/Frauen-rechts.dcc1cb57.jpg";